// Mock data for Campbell Connect portal clone (frontend-only)

export const company = {
  name: 'Campbell Connect',
  legal: 'Campbell Communications LLC',
  poweredBy: 'Powered by Campbell Communications LLC',
  logo: 'https://connect-campbell-portal.lovable.app/__l5e/assets-v1/5c2ef6da-daab-499d-9c7c-399b4473eee4/campbell-logo.JPG',
};

export const currentUser = {
  firstName: 'Jordan',
  lastName: 'Davis',
  initials: 'JD',
  email: 'jordan.davis@campbellconnect.com',
  phone: '(555) 018-2245',
  role: 'applicant',
  status: 'New Applicant',
  recruiter: 'Monica Reyes',
  profileCompletion: 75,
  address: '1420 Oak Meadow Dr, Austin, TX 78745',
  availability: 'Mon-Fri, 30 hrs/week',
};

export const heroStats = [
  { value: 'Secure', label: 'Supabase sign-in' },
  { value: 'Live', label: 'Onboarding tracking' },
  { value: 'Private', label: 'Document storage' },
];

export const dashboardStats = [
  { key: 'training', label: 'Training', value: '2/10', sub: '20% of curriculum', icon: 'GraduationCap' },
  { key: 'assessment', label: 'Assessment', value: 'Not taken', sub: '80% required to pass', icon: 'ClipboardCheck' },
  { key: 'certification', label: 'Certification', value: 'Pending', sub: 'Customer Service Representative', icon: 'Award' },
  { key: 'profile', label: 'Profile', value: '75%', sub: 'Profile completion', icon: 'ListChecks' },
];

export const timelineStages = [
  { n: 1, label: 'New Applicant', state: 'complete' },
  { n: 2, label: 'Profile Complete', state: 'inprogress' },
  { n: 3, label: 'Documents Submitted', state: 'locked' },
  { n: 4, label: 'Documents Approved', state: 'locked' },
  { n: 5, label: 'Equipment Verified', state: 'locked' },
  { n: 6, label: 'Orientation Complete', state: 'locked' },
  { n: 7, label: 'Training Complete', state: 'locked' },
  { n: 8, label: 'Final Assessment Passed', state: 'locked' },
  { n: 9, label: 'Certified Customer Service Representative', state: 'locked' },
  { n: 10, label: 'Opportunity Center Unlocked', state: 'locked' },
  { n: 11, label: 'Client Ready', state: 'locked' },
  { n: 12, label: 'Active Agent', state: 'locked' },
];

export const documents = [
  { id: 'resume', name: 'Resume', status: 'Approved' },
  { id: 'gov-id', name: 'Government ID', status: 'Approved' },
  { id: 'w9', name: 'W-9', status: 'Pending' },
  { id: 'direct-deposit', name: 'Direct Deposit Form', status: 'Missing' },
  { id: 'ica', name: 'Independent Contractor Agreement', status: 'Rejected' },
];

export const onboardingChecklist = [
  { n: 1, title: 'Complete Profile', desc: 'Personal details, address, and tax info', done: true },
  { n: 2, title: 'Upload Resume', desc: 'PDF or DOCX, max 10MB', done: true },
  { n: 3, title: 'Upload Government ID', desc: "Driver's license or passport", done: true },
  { n: 4, title: 'Upload W-9', desc: 'Required for 1099 contractors', done: false },
  { n: 5, title: 'Sign Independent Contractor Agreement', desc: 'E-signature', done: false },
  { n: 6, title: 'Equipment Verification', desc: 'Computer, headset, workspace', done: false },
  { n: 7, title: 'Internet Speed Check', desc: 'Minimum 25 Mbps down / 10 up', done: false },
  { n: 8, title: 'Background Check', desc: 'Optional for most placements', done: false },
  { n: 9, title: 'Orientation', desc: 'Company overview and policies', done: false },
  { n: 10, title: 'Training', desc: 'Ten core learning modules', done: false },
  { n: 11, title: 'Assessment', desc: '20 questions, 80% to pass', done: false },
  { n: 12, title: 'Certification', desc: 'Digital credential issued', done: false },
  { n: 13, title: 'Ready for Client Assignment', desc: 'Unlocks job opportunities', done: false },
];

export const announcements = [
  { id: 1, title: 'New Healthcare Support certification now open', body: 'Enroll from the Certification Center to qualify for Meridian Health placements.', date: 'Aug 3, 2026' },
  { id: 2, title: 'Orientation cohort — Thursday 10:00 AM CST', body: 'Live welcome session with the onboarding team. Attendance is recorded.', date: 'Aug 1, 2026' },
  { id: 3, title: 'Updated equipment standards', body: 'Minimum internet speed is now 25 Mbps download. Re-run your speed check.', date: 'Jul 28, 2026' },
];

export const notifications = [
  { id: 1, title: 'Welcome to Campbell Connect.', body: 'Your onboarding journey has started. Complete your profile to begin.' },
];

export const supportContacts = [
  { key: 'email', label: 'Email', value: 'support@campbellconnect.com', icon: 'Mail' },
  { key: 'phone', label: 'Phone', value: '(800) 555-0142', icon: 'Phone' },
  { key: 'chat', label: 'Live chat', value: 'Mon-Fri, 8am-6pm CST', icon: 'MessageSquare' },
];

export const faqs = [
  { q: 'What does it mean to be a 1099 independent contractor?', a: 'As a 1099 independent contractor you work for yourself and are responsible for your own taxes. Campbell Communications does not withhold taxes; you receive full pay and file a W-9 for reporting.' },
  { q: 'How long does onboarding take?', a: 'Most applicants complete onboarding in about 48 hours of active work, spread across profile setup, document approval, orientation, and training.' },
  { q: 'What equipment do I need?', a: 'A reliable computer, a USB headset with microphone, and a quiet dedicated workspace with at least 25 Mbps download internet speed.' },
  { q: 'What score do I need to pass the assessment?', a: 'The final assessment has 20 questions and you need to score 80% or higher to pass and earn certification.' },
  { q: 'When can I apply for client assignments?', a: 'The Opportunity Center unlocks once you are certified and marked client ready in your onboarding workflow.' },
];

export const employmentInfo = [
  { label: 'Current role', value: 'applicant' },
  { label: 'Current status', value: 'New Applicant' },
  { label: 'Recruiter assigned', value: 'Monica Reyes' },
  { label: 'Orientation date', value: 'Not scheduled' },
  { label: 'Training progress', value: '20%' },
  { label: 'Assessment score', value: 'Not taken' },
  { label: 'Certification status', value: 'Not certified' },
  { label: 'Client assignment', value: 'None' },
  { label: 'Hire date', value: '—' },
];

export const profileProgress = [
  { label: 'Overall', value: 8 },
  { label: 'Documents', value: 40 },
  { label: 'Training', value: 20 },
  { label: 'Certification', value: 0 },
];

export const achievements = [
  { title: 'Profile Completed', desc: 'Master profile fully filled out.' },
  { title: 'Documents Cleared', desc: 'Every required document approved.' },
  { title: 'Orientation Graduate', desc: 'Completed all orientation sections.' },
  { title: 'Training Graduate', desc: 'Finished all core training modules.' },
  { title: 'Certified CSR', desc: 'Earned the Customer Service Representative credential.' },
  { title: 'Client Ready', desc: 'Approved for client assignment.' },
  { title: 'Top Performer', desc: 'Scored 95% or higher on the final assessment.' },
];

export const navItems = [
  { key: 'dashboard', label: 'Dashboard', path: '/dashboard', icon: 'LayoutDashboard' },
  { key: 'onboarding', label: 'My Onboarding', path: '/onboarding', icon: 'ListChecks' },
  { key: 'documents', label: 'My Documents', path: '/documents', icon: 'FileText' },
  { key: 'announcements', label: 'Announcements', path: '/announcements', icon: 'Megaphone' },
  { key: 'support', label: 'Support', path: '/support', icon: 'LifeBuoy' },
  { key: 'profile', label: 'My Profile', path: '/profile', icon: 'User' },
  { key: 'settings', label: 'Settings', path: '/settings', icon: 'Settings' },
];
